module.exports = __webpack_public_path__ + "d5c6ac97e1f725b1f78e1e98920a5092.svg";